<template>
  <div class="table-responsive" style="overflow: auto">
    <table class="table tablesorter">
      <thead class="text-primary">
      <tr>
        <th style="max-width: 50px">
        </th>
        <th class="text-center">
          <code class="text-center text-warning" style="font-size: 16px">Article</code>
        </th>
        <th class="text-center">
          <code class="text-center text-warning" style="font-size: 16px">Amount</code>
        </th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(value, key) in totalPerArticles" :key="key" >
          <td>

          </td>
          <td class="text-center">
            {{key}}
          </td>
          <td class="text-center">
            <p :class="{ 'text-success': (parseInt(value)>0), 'text-danger': (parseInt(value)<0) }" >{{formatter.format(value/100)}}</p>
          </td>
        </tr>
        <tr>
          <td>
            <h4><b><code class="text-center text-warning" style="font-size: 18px">Total</code></b></h4>
          </td>
          <td class="text-center">
          </td>
          <td class="text-center">
            <h4><b v-bind:class="{ 'text-success': (parseInt(totalAmount)>0), 'text-danger': (parseInt(totalAmount)<0) }">{{formatter.format(totalAmount/100)}}</b></h4>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {formatter, isMobile} from "../../plugins/axios";
  export default {
    name: "incomes-report-total",
    props: ['totalPerArticles', 'totalAmount'],
    data(){
      return{
        formatter: formatter,
        isMobile: isMobile,
      }
    }
  }
</script>

<style scoped>

</style>
